<template>
	<div class="row">
      <div class="col-md-12 mb-2">
         <h4>WEEKLY TOP 10 STORES</h4>
      </div>

		<div class="col-md-12">
         <el-card shadow="never" class="box-card col-md-12 mb-2" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '8px', paddingBottom: '8px' }">
            <div slot="header" class="clearfix" v-if="false">
               <span><strong>WEEKLY TOP 10 STORES</strong></span>
            </div>

            <div>
               <el-tabs>
                  <el-tab-pane label="Top 10 Stores">
                     <div style="float:left;margin-top:0px;margin-bottom:10px;">
                        <el-input
                           v-model="tableProperties.search"
                           type="search"
                           class="focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-block tw-w-full tw-pl-10 sm:tw-text-sm tw-border-gray-300 tw-rounded-md"
                           :placeholder="`Search`"
                        />
                     </div>
                     <el-table
                        :data="this.displayData"
                        stripe
                        v-loading="loading.table"
                        :border="false"
                        :show-header="true"
                        :header-cell-style="{paddingTop: '5px', paddingBottom: '5px'}"
                        :header-row-style="{padding:'0px'}"
                        :cell-style="{padding: '8px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"
                        style="width: 100%;background-color:white;"
                        class="no-border"
                        id="table">
                        
                        <el-table-column :label="item.title" align="center" v-for="(item, index) in this.tableColumns()" :key="item.title+index">            
                           <el-table-column
                              v-for="(item2, index2) in item.children" :key="index2"
                              :prop="item2.field"
                              :label="item2.title" 
                              :sortable ="true"
                              
                              :width="(item2.field == 'storeName' ) ? '300':'100' "
                              :align="(item2.field == 'storeName' ) ? 'left':'center'"
                              header-align="center"
                              >
                           </el-table-column>
                        </el-table-column>
                     </el-table>

                     <div class="mt-4 mb-2" style="text-align: right;">
                        <el-pagination
                           background
                           layout="total, sizes, prev, pager, next, jumper"
                           @current-change="handleCurrentChange"
                           @size-change="changePerPage"
                           @currentPage="tableProperties.currentPage"
                           :page-sizes="[5, 10, 20, 30, 40, 50, 100]"                    
                           :page-size="tableProperties.pageSize"
                           :total="this.tableProperties.total">
                        </el-pagination>
                     </div>
                  </el-tab-pane>
                  <el-tab-pane label="Flop 10 Stores">
                     <div style="float:left;margin-top:0px;margin-bottom:10px;">
                        <el-input
                           v-model="flopTableProperties.search"
                           type="search"
                           class="focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-block tw-w-full tw-pl-10 sm:tw-text-sm tw-border-gray-300 tw-rounded-md"
                           :placeholder="`Search`"
                        />
                     </div>
                     <el-table
                        :data="this.displayFlopData"
                        stripe
                        v-loading="loading.table"
                        :border="false"
                        :show-header="true"
                        :header-cell-style="{paddingTop: '5px', paddingBottom: '5px'}"
                        :header-row-style="{padding:'0px'}"
                        :cell-style="{padding: '8px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"
                        style="width: 100%;background-color:white;"
                        class="no-border"
                        id="table">
                        
                        <el-table-column :label="item.title" align="center" v-for="(item, index) in this.flopTableColumns()" :key="item.title+index">            
                           <el-table-column
                              v-for="(item2, index2) in item.children" :key="index2"
                              :prop="item2.field"
                              :label="item2.title" 
                              :sortable ="true"
                              
                              :width="(item2.field == 'storeName' ) ? '300':'100' "
                              :align="(item2.field == 'storeName' ) ? 'left':'center'"
                              header-align="center"
                              >
                           </el-table-column>
                        </el-table-column>
                     </el-table>

                     <div class="mt-4 mb-2" style="text-align: right;">
                        <el-pagination
                           background
                           layout="total, sizes, prev, pager, next, jumper"
                           @current-change="handleCurrentChangeFlop"
                           @size-change="changePerPageFlop"
                           @currentPage="flopTableProperties.currentPage"
                           :page-sizes="[5, 10, 20, 30, 40, 50, 100]"                    
                           :page-size="flopTableProperties.pageSize"
                           :total="this.flopTableProperties.total">
                        </el-pagination>
                     </div>
                  </el-tab-pane>
               </el-tabs>
            </div>
         </el-card>

         <!--
			<div class="card cardptpr mb-4">
				<div class="card-header p-3 pb-0 pt-2">
					<H6>WEEKLY TOP 10 STORES</H6>
				</div>
				<div class="card-body p-3 pt-0">
					<ve-table 
                  v-if="this.weekly.top.tableData" border-y 
                  :columns="this.weekly.top.columns" 
                  :table-data="weekly.top.tableData" 
                  :sortOption="this.weekly.top.sortOption"
					>
               </ve-table>
            </div>
			</div>
         -->

         <!--
			<div class="card cardptpr mb-4">
				<div class="card-header p-3 pb-0 pt-2">
					<H6>WEEKLY FLOP 10 STORES</H6>
				</div>
				<div class="card-body p-3 pt-0">
					<ve-table v-if="this.weekly.flop.tableData" border-y :columns="this.weekly.flop.columns" :table-data="weekly.flop.tableData" :sortOption="this.weekly.top.sortOption"></ve-table>				
				</div>
			</div>
         -->
		</div>
	</div>
</template>

<style>

</style>

<script>
import Bright from '@/components/page/Bright.js'
import '@/plugin_easytable.js'

export default
{
	extends: Bright,
	components:{
		
	},
	props: {
		
	},
	data() {
		return {
			tableProperties: {
				filtered: [],
				search: '',
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
         flopTableProperties: {
				filtered: [],
				search: '',
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
		}
	},	
	watch:{
		// dataColumn(a,b){ alert(a+"tes"+b) }
	},    
	mounted(){
		this.$emit('childrenRoute')
		this.loadTopFlop();
   },    
	methods:{
      //TOP DATA
		handleCurrentChange(val) {
        this.tableProperties.currentPage = val;
      },

      changePerPage(val) {
         this.tableProperties.pageSize = val
      },

      displayData2(tableData) {
         if(tableData !== undefined) {
            if(this.tableProperties.search == null) return tableData;
         
            this.tableProperties.filtered = tableData.filter(data => !this.tableProperties.search || data.storeName.toLowerCase().includes(this.tableProperties.search.toLowerCase()));
            this.tableProperties.total = this.tableProperties.filtered.length;
            return this.tableProperties.filtered.slice(this.tableProperties.pageSize * this.tableProperties.currentPage - this.tableProperties.pageSize, this.tableProperties.pageSize * this.tableProperties.currentPage)
         }
         else
            return [];
      },
      tableColumns() {
         //let sortedColumnByString = this.sortColumns(this.weekly.top.columns);
         //let sortedColumnByNumber = this.weekly.top.columns.slice().sort((a, b) => a.title - b.title);
         return this.weekly.top.columns;
      },

      //FLOP DATA
      handleCurrentChangeFlop(val) {
        this.flopTableProperties.currentPage = val;
      },

      changePerPageFlop(val) {
         this.flopTableProperties.pageSize = val
      },
      displayFlopData2(tableData) {
         if(tableData !== undefined) {
            if(this.flopTableProperties.search == null) return tableData;
         
            this.flopTableProperties.filtered = tableData.filter(data => !this.flopTableProperties.search || data.storeName.toLowerCase().includes(this.flopTableProperties.search.toLowerCase()));
            this.flopTableProperties.total = this.flopTableProperties.filtered.length;
            return this.flopTableProperties.filtered.slice(this.flopTableProperties.pageSize * this.flopTableProperties.currentPage - this.flopTableProperties.pageSize, this.flopTableProperties.pageSize * this.flopTableProperties.currentPage)
         }
         else
            return [];
      },
      flopTableColumns() {
         return this.weekly.flop.columns;
      },

      sortColumns(columns) {
         let sorted = columns.slice().sort((a, b) => {
            let fa = a.title.toLowerCase(), fb = b.title.toLowerCase();
            if (fa < fb) {
               return -1;
            }
            if (fa > fb) {
               return 1;
            }
            return 0;
         });
         return sorted;
      },
      
      formatter(row, column) {
         return ((row.SalesExTax)/1000000).toFixed(2);
      },
	},
   computed: {
      displayData() {
         return this.displayData2(this.weekly.top.tableData);
      },
      displayFlopData() {
         return this.displayFlopData2(this.weekly.flop.tableData);
      },
   },
}
</script>
<style>
.home.row1,.home.row2{ height: 300px;}
.text-merah{ color:#c7251c }
.text-biru{ color:#066fb1   }
.text-hijau{ color:#acc437  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
  }

  .el-table--border::after, .el-table--group::after, .el-table::before {
      content: '';
      position: absolute;
      background-color: #FFF !important;
      z-index: 1;
  }
</style>